// src/stores/common.ts
import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userDataReducer from '@/stores/modules/user';
import reportsReducer from '@/stores/modules/reports';
import slugsReducer from '@/stores/modules/slugs';
import detailUrlReducer from '@/stores/modules/detailUrl';
import chatReducer from '@/stores/modules/chatBotMessages';
import chatAssistantReducer from '@/stores/modules/chatBotMessagesAssistant';

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  userData: userDataReducer,
  reports: reportsReducer,
  slugs: slugsReducer,
  detailUrl: detailUrlReducer,
  chat: chatReducer,
  chatAssistant: chatAssistantReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
        ignoredPaths: ['register'],
      },
    }),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
